var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnlock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.889 11.455c.611 0 1.111.49 1.111 1.09v4.364c0 .6-.5 1.091-1.111 1.091H8.11C7.5 18 7 17.51 7 16.91v-4.365c0-.6.5-1.09 1.111-1.09V9.818C8.111 7.713 9.856 6 12 6s3.889 1.713 3.889 3.818zm-2.222 0V9.818c0-.902-.748-1.636-1.667-1.636s-1.667.734-1.667 1.636v1.637z"
})));
export { SvgUnlock as ReactComponent };
export default __webpack_public_path__ + "static/media/unlock.aa108ad3.svg";